import axioscommon from './axios-common';
import authHeader from './auth-header';

const defaultSettings = require('@/settings.js');
const API_URL = defaultSettings.apiUrl + '/api';

class ProductService {
    getProducts(onlyActive) {
        if (onlyActive) {
            return axioscommon.get(API_URL + '/products/onlyActive', { headers: authHeader() });
        }
        return axioscommon.get(API_URL + '/products/', { headers: authHeader() });
    }
    updateProduct(data) {
        return axioscommon.put(API_URL + '/products/', data, { headers: authHeader() });
    }
    saveProduct(data) {
        return axioscommon.post(API_URL + '/products/', data, { headers: authHeader() });
    }

    // issue related products.
    getAllProductList() {
        return axioscommon.get(API_URL + '/issueproducts/', { headers: authHeader() });
    }
    getThisMonthPLs() {
        return axioscommon.get(API_URL + '/issueproducts/month', { headers: authHeader() });
    }
    getProductList(issueId) {
        return axioscommon.get(API_URL + '/issueproducts/' + issueId, { headers: authHeader() });
    }
    closeProductsList(data) {
        return axioscommon.put(API_URL + '/issueproducts/', data, { headers: authHeader() });
    }
    postProductsList(issueId, data) {
        return axioscommon.post(API_URL + '/issueproducts/' + issueId, data, { headers: authHeader() });
    }
    removeProductFromProductList(issueId, productId) {
        return axioscommon.delete(API_URL + '/issueproducts/' + issueId + '/' + productId, { headers: authHeader() });
    }

    updateProductListItem(productId, data) {
        return axioscommon.put(API_URL + '/productline/' + productId, data, { headers: authHeader() });
    }

}

export default new ProductService();
